export default __webpack_public_path__ + "a408a09d4d0a219f0181c6f76ce30e3b.glb";